









import { defineComponent, onBeforeUnmount, onBeforeMount, onMounted } from '@vue/composition-api';
import Cookies from 'js-cookie';
import { getQueryString, clearLocalStorageKeys, createSessionKey } from '@/libs/util';
import useSensorsData from '@/mixins/useSensorsData';
import i18n from '@/locales';
import { loadAds as loadThirdPartyAds } from './libs/adversting';

export default defineComponent({
    name: 'App',
    setup(props, ctx) {
        const { loadSensorsData } = useSensorsData();
        loadSensorsData();

        const safariHacks = () => {
            const appElem = document.getElementById('app');
            if (appElem) {
                const windowsVH = window.innerHeight / 100;
                appElem.style.setProperty('--vh', `${windowsVH}px`);
            }
        };

        const loadChatWidgetSDK = (isDefault = true) => {
            let scriptContent = '';
            if (isDefault) {
                const isZH = ['zh-CN', 'zh-TW'].includes(i18n.locale);
                const chatWidgetSDKPath = process.env.VUE_APP_CHAT_PLUGIN_URL as string;
                const chatWidgetCode = process.env[isZH ? 'VUE_APP_CHAT_WIDGET_ZH_CODE' : 'VUE_APP_CHAT_WIDGET_EN_CODE'] as string;
                console.log('loadChatWidgetSDK chatWidgetSDKPath chatWidgetCode--->>', chatWidgetSDKPath, chatWidgetCode);
                scriptContent = `
                    (function(d, s, id, w, n) {
                        w.__ssc = w.__ssc || {};
                        w.__ssc.license = '${chatWidgetCode}';
                        w.__ssc.setting = { r_o_url: btoa(w.location.origin) };
                        if (w.ssq) return false;
                        n = w.ssq = function() {n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        n.push=n;n.loaded=!0;n.queue=[];
                        var js, sjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) return;
                        js = d.createElement(s); js.id = id;
                        js.src = '${chatWidgetSDKPath}';
                        sjs.parentNode.insertBefore(js, sjs);
                    }(document, 'script', 'ss-chat', window));
                `;
            } else if (window.__siteConfig && window.__siteConfig.pluginJS) {
                // 如果有自定义的插件JS，则加载
                const chatWidgetSDKPath = window.__siteConfig.pluginJS;
                scriptContent = `
                    (function (d, s, w) {
                        var js, sjs = d.getElementsByTagName(s)[0];
                        js = d.createElement(s);
                        js.src = '${chatWidgetSDKPath};
                        sjs.parentNode.insertBefore(js, sjs);
                    }(document, 'script', window));
                `;
            }
            if (scriptContent) {
                const $js = document.getElementById('s-s-c-w');
                if ($js) {
                    $js.innerHTML = scriptContent;
                } else {
                    const script = document.createElement('script');
                    script.id = 's-s-c-w';
                    script.innerHTML = scriptContent;
                    document.body.appendChild(script);
                }
            }
        };

        const initChatWidgetSDK = () => {
            console.log('initChatWidgetSDK');
            let isIframe;
            try {
                isIframe = window.top && window.top !== window.self;
            } catch {
                isIframe = false;
            }
            if (!isIframe) {
                if (
                    window.location.hostname.indexOf('salesmartly') > -1 ||
                    window.location.hostname.indexOf('ss-chat.com') > -1
                ) {
                    loadChatWidgetSDK();
                } else if (window.__siteConfig && window.__siteConfig.pluginJS) {
                    loadChatWidgetSDK(false);
                }
            }
        };

        onBeforeMount(() => {
            // 挂载聊天插件 sdk
            initChatWidgetSDK();

            // 清除本地存储
            const logBlackList = ['fclog_'];
            if (localStorage && localStorage.length > 100) {
                const matchedKeys: string[] = [];

                for (let i = 0; i < localStorage.length; i += 1) {
                    const key = localStorage.key(i);
                    if (key && logBlackList.some((prefix) => key.startsWith(prefix))) {
                        matchedKeys.push(key);
                    }
                }

                console.log('matchedKeys 数量:', matchedKeys.length);

                if (matchedKeys.length > 50) {
                    console.warn(`黑名单 key 数量 (${matchedKeys.length}) 超过 50，开始清理`);

                    // 比如只保留最新的50个，其余删除
                    const toDelete = matchedKeys.slice(0, matchedKeys.length - 50);
                    toDelete.forEach((key) => localStorage.removeItem(key));

                    console.log(`已删除 ${toDelete.length} 个黑名单 key`);

                    ctx.root.$log('STORAGE_ERROR', 'REMOVE_LOCAL_STORAGE_KEY', {
                        data: {
                            localStorageLength: localStorage.length,
                            matchedKeysLength: matchedKeys.length,
                            deleteLength: toDelete.length,
                        },
                    });
                }
            }
        });

        onMounted(() => {
            safariHacks();
            window.addEventListener('resize', safariHacks);

            window.postMessage({
                payload: 'removeLoading',
            }, window.location.origin);

            let domain = '';
            try {
                domain = document.domain.split('.').slice(-2).join('.');
            } catch (e) {
                console.error(e);
                ctx.root.$log('SS_COOKIES', 'SS_COOKIES_ERROR', { data: { domain: document.domain } });
            }

            /* 缓存对应参数至 cookies */
            const ref = getQueryString('ref');
            if (ref) {
                Cookies.set('ref', ref, {
                    expires: 30,
                    domain,
                });
            }

            const agent = getQueryString('agent');
            if (agent) {
                Cookies.set('agent', agent, {
                    expires: 30,
                    domain,
                });
            }

            if (window.location.hostname.indexOf('salesmartly') > -1 || window.location.hostname.indexOf('ss-chat.com') > -1) {
                // 指定域名下加载广告
                loadThirdPartyAds();
            }

            // 插入 data4 sdk
            if (window.location.hostname === 'app.salesmartly.com') {
                const _script = document.createElement('script');
                _script.id = 'tracker-script';
                _script.src = 'https://console.data4.net/static/js/tracker.js';
                _script.defer = true;
                _script.setAttribute('data-website-id', 'bcbc146c8c164f8994f73418fb7caf02');
                document.body.appendChild(_script);
            } else if (window.location.hostname === 'app.salesmartly.cn') {
                const _script = document.createElement('script');
                _script.id = 'tracker-script';
                _script.src = 'https://console.data4.net/static/js/tracker.js';
                _script.defer = true;
                _script.setAttribute('data-website-id', '924e7211c72a457c86b78405d1093e28');
                document.body.appendChild(_script);
            }

            // 清除本地存储
            if (localStorage && localStorage.length > 3000) {
                clearLocalStorageKeys();
            }

            createSessionKey();
        });

        onBeforeUnmount(() => {
            window.removeEventListener('resize', safariHacks);
        });

        return {};
    },
});
